import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import { Autocomplete } from "@mui/material";

// Muwafiq components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import crudsService from "services/cruds-service";

import FormField from "components/FormField";
import i18n from "i18n";
import MDInput from "components/MDInput";

const FilterArticle = ({ setFilterUrl }) => {
  const [tags, setTags] = useState([]);

  const { t } = i18n;

  const [info, setInfo] = useState({
    title: "",
    tag_id: "",
  });

  const prepareNewArr = (arr, objKey) => {
    let newArr = [];
    for (const key in arr) {
      if (Object.hasOwnProperty.call(arr, key)) {
        const element = arr[key];
        newArr.push({
          id: element.id,
          name: element?.translations[0][objKey || "name"],
        });
      }
    }
    console.log(newArr);

    return newArr;
  };

  useEffect(() => {
    (async () => {
      try {
        const tagsData = await crudsService.getAllData(
          "items/tags?fields=id,translations.name&filter[type][_eq]=a",
        );
        setTags(prepareNewArr(tagsData.data));
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, []);

  const changeHandler = (e) => {
    setInfo({
      ...info,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      console.log(info);

      let str = "";
      const values = {};

      if (info.tag_id) {
        values["tag_id"] = {
          key: "[tags][tags_id]",
          filter: "_eq",
          val: info.tag_id?.id,
        };
      }

      if (info.title) {
        values["title"] = {
          key: "[translations][title]",
          filter: "_contains",
          val: info.title,
        };
      }

      const keys = Object.keys(values);
      keys.forEach((element) => {
        if (
          values[element] &&
          (!Array.isArray(values[element]) || values[element].length > 0)
        ) {
          str += `&filter${values[element]["key"] || `[${element}]`}[${
            values[element]["filter"] || "_eq"
          }]=${values[element]["val"] || values[element]}`;
        }
      });

      setFilterUrl(str);
    } catch (err) {
      console.log({ error: true, textError: err.message });
      return null;
    }
  };

  return (
    <MDBox
      component="form"
      method="POST"
      onSubmit={submitHandler}
      encType="multipart/form-data"
    >
      <MDBox display="flex" flexDirection="column" px={2} my={4}>
        <MDBox display="flex" flexDirection="column">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormField
                onChange={changeHandler}
                label={"العنوان"}
                name="title"
                value={info.title}
                placeholder="العنوان"
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={tags}
                name="tag_id"
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.data ? option.data.name : option.name}
                  </li>
                )}
                getOptionLabel={(option) => {
                  if (option.data) {
                    if (option.data.name) return option.data.name;
                  } else {
                    if (option) {
                      if (option.name) return option.name;
                    }
                  }
                  return "";
                }}
                isOptionEqualToValue={(option, item) =>
                  option === item || option?.id === item?.id
                }
                variant="outlined"
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    //variant="standard"
                    label="الوسم"
                  />
                )}
                onChange={(e, v) =>
                  changeHandler({
                    target: { name: "tag_id", value: v },
                  })
                }
                value={info.tag_id || null}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
          <MDButton variant="gradient" color="info" size="small" type="submit">
            {t("search")}
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default FilterArticle;
